import React, { useState } from 'react';
import { Input, Modal, Spin, Checkbox } from 'antd';
import { useNavigate } from 'react-router-dom';
import { usePackingForm } from './hooks/usePackingForm';
import SharedActionBar from '../../components/SharedActionBar/SharedActionBar';

const PW1115F1Form: React.FC = () => {
  const navigate = useNavigate();
  const {
    mode, isEditing, loading,
    records, current, currentIdx,
    code, setCode,
    desc, setDesc,
    isOld, setIsOld,
    navFirst, navPrev, navNext, navLast,
    startAdd, startEdit, startCopy, cancel, save,
    doDelete, quickSearch,
  } = usePackingForm();

  const [searchText, setSearchText] = useState('');

  const handleDelete = () => {
    if (!current) return;
    Modal.confirm({
      title: '確認刪除',
      content: `確定要刪除包裝代號「${current.f115_01}」？`,
      okText: '刪除',
      okType: 'danger',
      cancelText: '取消',
      onOk: doDelete,
    });
  };

  const handleQuickSearch = () => {
    if (searchText.trim()) {
      quickSearch(searchText.trim());
    }
  };

  return (
    <Spin spinning={loading}>
      <div className="max-w-2xl mx-auto p-6 pb-20">
        {/* Title */}
        <h2 className="text-xl font-bold mb-4">
          包裝方式建檔
          <span className="ml-3 text-sm font-normal text-gray-500">
            {records.length > 0 ? `${currentIdx + 1} / ${records.length}` : '無資料'}
          </span>
        </h2>

        {/* Quick Search Bar */}
        <div className="flex items-center gap-2 mb-6">
          <Input
            placeholder="輸入代號或說明快速查詢"
            value={searchText}
            onChange={e => setSearchText(e.target.value)}
            onPressEnter={handleQuickSearch}
            disabled={isEditing}
            style={{ width: 300 }}
            maxLength={150}
          />
          <button
            className="sab-btn"
            onClick={handleQuickSearch}
            disabled={isEditing}
          >
            查詢
          </button>
        </div>

        {/* Form Fields */}
        <div className="space-y-4 mb-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              包裝代號 <span className="text-red-500">*</span>
            </label>
            <Input
              value={code}
              onChange={e => setCode(e.target.value)}
              maxLength={2}
              disabled={mode !== 'add'}
              style={{ width: 120 }}
              placeholder="最多2字元"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              包裝說明 <span className="text-red-500">*</span>
            </label>
            <Input.TextArea
              value={desc}
              onChange={e => setDesc(e.target.value)}
              maxLength={150}
              disabled={!isEditing}
              style={{ width: 500 }}
              rows={5}
              placeholder="最多150字"
            />
          </div>

          <Checkbox
            checked={isOld}
            onChange={e => setIsOld(e.target.checked)}
            disabled={!isEditing}
          >
            舊 代 號
          </Checkbox>
        </div>

        {/* Audit Fields (read-only) */}
        {current && mode === 'browse' && (
          <div className="text-xs text-gray-400 mb-6 space-y-1">
            <div>建立人員: {current.f115_91} | 建立日期: {current.f115_92 || '-'}</div>
            <div>修改人員: {current.f115_93}</div>
          </div>
        )}
      </div>

      {/* SharedActionBar — bottom fixed */}
      <SharedActionBar
        mode={mode}
        isEditing={isEditing}
        hasRecord={!!current}
        currentIdx={currentIdx}
        recordCount={records.length}
        onNavFirst={navFirst}
        onNavPrev={navPrev}
        onNavNext={navNext}
        onNavLast={navLast}
        onAdd={startAdd}
        onModify={startEdit}
        onDelete={handleDelete}
        onSave={save}
        onCancel={cancel}
        onCopy={startCopy}
        onExit={() => navigate(-1)}
      />
    </Spin>
  );
};

export default PW1115F1Form;
